import { IoClose } from "react-icons/io5";

const Modal = ({
  isOpen,
  onClose,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-[90vw] max-w-md mx-auto p-4 rounded-lg shadow-lg relative">
        <button
          className="absolute top-4 left-3 text-slate-600"
          onClick={onClose}
        >
          <IoClose size={26} />
        </button>
        <div className="mt-8">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
